export default __webpack_public_path__ + "static/media/leila_zerrougui.1b0c9134.m4a";